import { Button } from "@/components/ui/button";
import { ArrowRight, MessageCircle } from "lucide-react";

export const HeroSection = () => {
  return (
    <section className="relative min-h-[90vh] md:min-h-[85vh] flex items-center justify-center px-4 sm:px-6 lg:px-8 py-16 md:py-20 overflow-hidden">
      {/* Clean background */}

      <div className="max-w-5xl mx-auto relative z-10 w-full">
        <div className="text-center space-y-6 md:space-y-8">
          {/* Badge */}
          <div className="animate-fade-in-up">
            <span className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full bg-primary/20 backdrop-blur-sm border border-primary/40 text-primary text-xs sm:text-sm font-medium shadow-lg shadow-primary/10">
              <span className="w-1.5 sm:w-2 h-1.5 sm:h-2 bg-primary rounded-full animate-pulse" />
              +30 empresas ya crecen con nosotros
            </span>
          </div>

          {/* Main Headline */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-primary leading-tight tracking-tight animate-fade-in-up">
            No somos una agencia más.
            <br />
            <span className="text-primary-foreground bg-primary/55 px-3 py-1 rounded-2xl inline-block mt-2">Somos tu ecosistema completo.</span>
          </h1>

          {/* Subheadline */}
          <p className="text-base sm:text-lg md:text-xl text-primary max-w-xl md:max-w-2xl mx-auto leading-relaxed animate-fade-in-up animate-delay-100 px-2">
            Conectamos pauta + estrategia + contenido + diseño.
            <br className="hidden sm:block" />
            Y si no tenés web, la creamos.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 pt-2 sm:pt-4 animate-fade-in-up animate-delay-200 px-4 sm:px-0">
            <Button 
              size="lg" 
              className="group bg-primary hover:bg-primary-hover text-primary-foreground px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg font-semibold rounded-full hover-lift w-full sm:w-auto shadow-lg shadow-primary/15 hover:shadow-primary/25 transition-all duration-300"
              onClick={() => {
              window.open(`https://wa.me/50670473873?text=${encodeURIComponent("Hola! Quiero agendar una llamada.")}`, '_blank');
              }}
            >
              <MessageCircle className="mr-2 h-4 sm:h-5 w-4 sm:w-5" />
              Agendá una llamada
              <ArrowRight className="ml-2 h-4 sm:h-5 w-4 sm:w-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            
            <Button 
              variant="outline" 
              size="lg"
              className="px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg rounded-full border-border/70 bg-background/50 backdrop-blur-sm hover:bg-accent/15 hover:border-accent hover:text-accent w-full sm:w-auto transition-all duration-300"
              onClick={() => {
                document.getElementById('cases')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Ver resultados
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
